import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import account from './modules/account'
import factory from './modules/factory'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        account,
        factory
    },
    getters
})

export default store
